










export default {
  name: "ExerciseInstructions",
  props: {
    body: {
      type: Array,
      required: true
    }
  }
};
